import React, { FC, useEffect } from 'react';

import { Box } from '@mantine/core';

import { useComponentSearchData } from 'components/component-overview/hooks/use-component-search-data';
import { InternalTrackingService } from 'services/InternalTrackingService';

const ImpressionTracker: FC<{
    namespace: string;
    data: object;
    position?: number;
    includeSearchData?: boolean;
    search?: object;
    children: React.ReactNode;
}> = ({ namespace, data, position, includeSearchData = true, search, children }) => {
    const { request } = useComponentSearchData();

    const searchData = search ?? (includeSearchData ? request : {});

    useEffect(() => {
        InternalTrackingService.track(`${namespace}.view`, {
            ...data,
            search: searchData,
            position,
        });
    }, []);

    const handleClick = () => {
        InternalTrackingService.track(`${namespace}.click`, {
            ...data,
            search: searchData,
            position,
        });
    };

    return (
        <Box display="grid" onClick={handleClick}>
            {children}
        </Box>
    );
};

export { ImpressionTracker };
